// Version : 1.0.0
// Author : AGALYA

import demandCollectionActionTypes from './demand-collection.types';

/** ***************** GET MEMBER LOAN INFO START *********************** */
export const fetchDemandMemberLoanInfoStart = (getData: any) => ({
	type: demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_START,
	payload: getData,
});

export const fetchDemandMemberLoanInfoSuccess = (successData: any) => ({
	type: demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const fetchDemandMemberLoanInfoFailure = (failureData: unknown) => ({
	type: demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchDemandMemberLoanInfoResponseResetStart = () => ({
	type: demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_RESPONSE_RESET,
});

export const fetchDemandMemberLoanInfoResponseChanged = () => ({
	type: demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER LOAN INFO END *********************** */

/** ***************** UPDATE DEMAND COLLECTION START *********************** */
export const updateDemandCollectionRevertStart = (getData: any) => ({
	type: demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_START,
	payload: getData,
});

export const updateDemandCollectionRevertSuccess = (successData: any) => ({
	type: demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_SUCCESS,
	payload: successData,
});

export const updateDemandCollectionRevertFailure = (failureData: unknown) => ({
	type: demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_FAILURE,
	payload: failureData,
});

export const updateDemandCollectionRevertResponseResetStart = () => ({
	type: demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_RESET,
});

export const updateDemandCollectionRevertResponseChanged = () => ({
	type: demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_CHANGED,
});
/** ***************** UPDATE DEMAND COLLECTION END *********************** */

/** ***************** UPDATE THRIFT PAID START *********************** */
export const updateThriftPaidStart = (getData: any) => ({
	type: demandCollectionActionTypes.UPDATE_THRIFT_PAID_START,
	payload: getData,
});

export const updateThriftPaidSuccess = (successData: any) => ({
	type: demandCollectionActionTypes.UPDATE_THRIFT_PAID_SUCCESS,
	payload: successData,
});

export const updateThriftPaidFailure = (failureData: unknown) => ({
	type: demandCollectionActionTypes.UPDATE_THRIFT_PAID_FAILURE,
	payload: failureData,
});

export const updateThriftPaidResponseResetStart = () => ({
	type: demandCollectionActionTypes.UPDATE_THRIFT_PAID_RESPONSE_RESET,
});

export const updateThriftPaidResponseChanged = () => ({
	type: demandCollectionActionTypes.UPDATE_THRIFT_PAID_RESPONSE_CHANGED,
});
/** ***************** UPDATE THRIFT PAID END *********************** */
